/* RESPONSIBLE TEAM: team-inbox */
import Controller from '@ember/controller';

export default class WorkspaceInboxInboxController extends Controller {
  queryParams = ['custom_folder_id'];
}
